import React, { useEffect } from "react";
import { Button, Img, Text } from "components";
import { useTranslation } from "react-i18next";
import { SavedAddressesListItem } from "components/SavedAddressesListItem";
import { updateMyAddress } from "../../../../../redux/reducers/myAddress";
import { useDispatch, useSelector } from "react-redux";
import * as CUSTOM from "../../../../../utils/helper/custom";
import {
  updateOrderData,
  getOrderData,
} from "../../../../../redux/reducers/orderData";
import { addDeleteGetLocalStorage, checkoutStorageKeys } from "utils/global/localData";
import { useAppFont } from "utils/helper/useAppFont";

const SavedAddressesList = (props) => {
  const { addressList, setAddAddressPopup, AddAddressPopup,
    isEventSent,
    setIsEventSent,
    sendCheckoutGaEvent
  } = props;
  const dispatch = useDispatch();
  const orderData = useSelector(getOrderData);
  const { t } = useTranslation();

  const [selectedAddressData, setSelectedAddressData] = React.useState({
    homeAddress: {},
    addressIndex: -1,
    selected: false,
  });
  const { interClass } = useAppFont();

  const deliverHear = () => {
    if (!isEventSent?.addShippingInfo) {
      setIsEventSent((prev) => ({ ...prev, addShippingInfo: true }));
      sendCheckoutGaEvent("add_shipping_info");
    }
    dispatch(
      updateOrderData({
        ...orderData,
        pageStep: 3,
        home_office: selectedAddressData?.homeAddress,
        delivery_mode: "home_office",
        deliveryDateTimeActiveTab: undefined,
      })
    );
    addDeleteGetLocalStorage(
      checkoutStorageKeys.DELIVERY_DETAILS,
      {
        delivery_mode: "home_office",
        home_office: selectedAddressData?.homeAddress,  // FIXED
      },
      "add",
      "single"
    );
  };

  const handleEditAddress = (addressItem) => {
    setAddAddressPopup(true);

    dispatch(
      updateMyAddress({
        ...CUSTOM.defaultAddressParams(),
        ...addressItem,
        isEdit: true,
      })
    );
  };

  useEffect(() => {
    if (orderData?.pageStep !== 2) {
      return;
    }

    const savedDeliveryDetails = addDeleteGetLocalStorage(
      checkoutStorageKeys.DELIVERY_DETAILS,
      {},
      "get"
    );

    if (savedDeliveryDetails && addressList && addressList.length > 0) {
      try {
        const deliveryData = JSON.parse(savedDeliveryDetails);

        if (deliveryData.delivery_mode === "home_office" && deliveryData.home_office) {
          const savedAddress = deliveryData.home_office.itemDetail || deliveryData.home_office;
          const savedAddressId = savedAddress?.id;
          const matchingIndex = addressList.findIndex(
            addr => addr.id === savedAddressId
          );

          if (matchingIndex !== -1) {
            setSelectedAddressData({
              homeAddress: {
                address: CUSTOM.buildFullAddress(addressList[matchingIndex]),
                itemDetail: addressList[matchingIndex],
              },
              addressIndex: matchingIndex,
              selected: true,
            });
          } else {
            const matchByFields = addressList.findIndex(addr =>
              addr.street_name === savedAddress?.street_name &&
              addr.building_no === savedAddress?.building_no &&
              addr.flat_no === savedAddress?.flat_no
            );

            if (matchByFields !== -1) {
              setSelectedAddressData({
                homeAddress: {
                  address: CUSTOM.buildFullAddress(addressList[matchByFields]),
                  itemDetail: addressList[matchByFields],
                },
                addressIndex: matchByFields,
                selected: true,
              });
            }
          }
        }
      } catch (e) {
        console.error("Error restoring address selection:", e);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressList, orderData?.pageStep]);

  return (
    <>
      <div className="mt-2.5 w-full">
        {!AddAddressPopup ? (
          <>
            <Text className={`text-[20px] leading-[28px] font-medium  text-[#1A1A1A] mb-6 sm:text-[16px] sm:leading-[24px] ${interClass}`}>
              {t("savedAddresses")}
            </Text>

            <div className="flex flex-col gap-4">
              {addressList?.length ? (
                <SavedAddressesListItem
                  addressList={addressList}
                  selectedAddressData={selectedAddressData}
                  setSelectedAddressData={setSelectedAddressData}
                  onEditAddress={handleEditAddress}
                />
              ) : (
                <div className="text-center py-8 text-gray-500">
                  {t("data_not_found")}
                </div>
              )}

              <div className="w-full h-px bg-gray-300"></div>

              <div className="flex items-center justify-between w-full gap-4 pt-2 sm:flex-col">

                <button
                  className="flex items-center justify-center gap-2 h-[44px] px-6 rounded-full border border-gray-300 bg-[white] text-[#1A1A1A] sm:w-full"
                  onClick={() => {
                    setAddAddressPopup(true);
                    dispatch(updateMyAddress(CUSTOM.defaultAddressParams()));
                  }}
                >
                  <span className="text-lg leading-none font-[Unbounded] sm:test-[14px]">+</span>
                  <span
                    className="
                      items-center text-center
                      text-[#1A1A1A] font-[Unbounded] font-medium
                      text-[14px] leading-[20px]
                      sm:text-[14px] sm:whitespace-nowrap
                    "
                  >
                    {t("newAddress")}
                  </span>
                </button>

                <Button
                  disabled={!selectedAddressData?.selected}
                  className={`h-[44px] px-8 rounded-full text-sm font-medium font-[Unbounded] transition sm:text-[14px] sm:w-full
                    ${selectedAddressData?.selected
                      ? "bg-[#771237] text-[white] hover:bg-[#5f0e2c] cursor-pointer font-[Unbounded]"
                      : "bg-gray-200 text-gray-400 cursor-not-allowed"
                    }`}
                  onClick={deliverHear}
                >
                  <span className="sm:whitespace-nowrap sm:text-[14px]">{t("selectAddress")}</span>
                </Button>
                {/* {addressList?.length ? (
                  <Button
                    className="w-auto mx-auto px-3 py-1.5 text-sm xs:mx-0" // "common-pointer bg-black-900 cursor-pointer font-nunitomedium h-12 py-2.5 px-3.5 rounded text-base text-center text-white-A700 w-auto"
                    size="sm"
                    variant={
                      !selectedAddressData?.selected ? "FillBlack" : "OutlineBlack"
                    }
                    hover={!selectedAddressData?.selected ? false : true}
                    hoverclass="bg-black-900"
                    disabled={!selectedAddressData?.selected}
                    onClick={deliverHear}
                  >
                    {t("continue")}
                  </Button>
                ) : null} */}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default SavedAddressesList;
